import { LayoutWrapper } from './AppLayout.styled';
import { AppLayoutProps } from './AppLayout.types';
import { Content } from './content';
import { Topbar } from './topbars';

function AppLayout({ children }: AppLayoutProps) {
  return (
    <LayoutWrapper>
      <Topbar />
      <Content>{children}</Content>
    </LayoutWrapper>
  );
}
export default AppLayout;
